import {debounce} from '../Functions/Utilities';

export function initSearchAutoComplete() {
  document.querySelectorAll('input.js-searchBox').forEach((searchBox: HTMLInputElement) => {
    initAutoComplete(searchBox);
  });
}

function initAutoComplete(searchBox: HTMLInputElement) {
  const ul = searchBox.parentElement?.querySelector('.js-searchAutocomplete');
  let resultLength = 0;
  if (!(ul instanceof HTMLElement)) {
    return;
  }
  const listener = debounce(
    async () => {
      const response = await fetch(ul.dataset.searchPage + '?type=7384&tx_solr[queryString]=' + searchBox.value);
      const list = await response.json();
      if (!list.suggestions) {
        return;
      }
      setAutocompleteList(Object.keys(list.suggestions).filter(word => word.length >= 2), ul, searchBox.value);
      resultLength = list.length;
    },
    200,
  );
  searchBox.addEventListener('input', listener);
  searchBox.addEventListener('focusin', listener);
  searchBox.addEventListener('focusin', () => {
    ul.classList.remove('hide');
    searchBox.classList.add('input__search--showAutocomplete');
  });
  searchBox.addEventListener('focusout', debounce(
    () => {
      ul.classList.add('hide');
      searchBox.classList.remove('input__search--showAutocomplete');
    },
    200));
}

function setAutocompleteList(list: string[], ul: HTMLElement, searchWord: string) {
  const searchPageUri = ul.dataset.searchPage;
  let html = '';
  for (const word of list) {
    let start = word.indexOf(searchWord.toLowerCase());
    let end = start + searchWord.length;
    let firstSubWord = word.substring(0, start);
    let lastSubWord = word.substring(end);
    if (start >= 0) {
      let displaysearch = `<span class="searchWord">${searchWord}</span>`;
      html += `<li><a class="button button--noButton" href="` + searchPageUri + `?tx_solr[q]=${word}">${firstSubWord}${displaysearch}${lastSubWord}</a></li>`;
    }
  }
  ul.innerHTML = html;
}
